import {$} from "./Frontend";

export class TableScroller {
    private _$leftButton: JQuery;
    private _$rightButton: JQuery;

    private _$table: JQuery|null;
    private _$tableHead: JQuery;
    private _$tableBody: JQuery;

    private _hasScroll = false;
    private _maxScroll = 0;

    private _doUpdate = false;

    constructor(private _$tableGetter: () => JQuery, private _config: {scrollStep?: number} = {}) {
        this._$table = null;

        this._mergeConfig();
    }

    update() {
        // defer the update to the time when the scroller has been initialized
        if (!this._$table || !this._$table.data('hasControls')) {
            this._doUpdate = true;
            return;
        }

        this._hasScroll = this._$tableHead.get(0).scrollWidth - 1 > this._$tableHead.width();
        this._maxScroll = this._$tableHead.get(0).scrollWidth - this._$tableHead.width() - 10;

        this._updateButtons();
    }

    _updateButtons() {
        this._$leftButton.toggleClass('visible', this._hasScroll && this._$tableHead.scrollLeft() !== 0);
        this._$rightButton.toggleClass('visible', this._hasScroll && this._$tableHead.scrollLeft() < this._maxScroll);

        const buttonPosition = this._$table[0].offsetTop;
        const height = this._$table.height();
        this._updateButton(this._$leftButton, buttonPosition, height);
        this._updateButton(this._$rightButton, buttonPosition, height);
    }

    _updateButton($button: JQuery, position: number, height: number) {
        $button.css('top', position);
        $button.css('height', height + 'px');
        $button.find('span:nth-child(2)').toggleClass('hidden', height < Math.max(window.top.innerHeight * 1.2, 500));
        $button.find('span:nth-child(3)').toggleClass('hidden', height < 250);
    }

    init() {
        if (!this._$table) {
            this._$table = this._$tableGetter();
        }
        if (this._$table.length !== 1) {
            throw new Error('Only single-element tables are allowed')
        }
        if (this._$table.data('hasControls')) {
            // do not double initialize
            return;
        }

        this._$table = this._$table.find('.dataTables_scroll');
        this._$tableHead = this._$table.find('.dataTables_scrollHead');
        this._$tableBody = this._$table.find('.dataTables_scrollBody');

        this._$leftButton = $(
            '<div class="btn-scroll-left btn-scroll">' +
            '<span class="fa fa-chevron-left" aria-hidden="true"></span>' +
            '<span class="fa fa-chevron-left" aria-hidden="true"></span>' +
            '<span class="fa fa-chevron-left" aria-hidden="true"></span>' +
            '</div>'
        )
            .on('click', () => {
                if (this._hasScroll) {
                    this._$tableHead.animate({
                        scrollLeft: '-=' + this._config.scrollStep + 'px',
                    });
                    this._$tableBody.animate({
                        scrollLeft: '-=' + this._config.scrollStep + 'px',
                    }, {
                        complete: () => this._updateButtons(),
                    });
                }
            })
        ;
        this._$rightButton = $(
            '<div class="btn-scroll-right btn-scroll">' +
            '<span class="fa fa-chevron-right" aria-hidden="true"></span>' +
            '<span class="fa fa-chevron-right" aria-hidden="true"></span>' +
            '<span class="fa fa-chevron-right" aria-hidden="true"></span>' +
            '</div>'
        )
            .on('click', () => {
                if (this._hasScroll) {
                    this._$tableHead.animate({
                        scrollLeft: '+=' + this._config.scrollStep + 'px',
                    });
                    this._$tableBody.animate({
                        scrollLeft: '+=' + this._config.scrollStep + 'px',
                    }, {
                        complete: () => this._updateButtons(),
                    });
                }
            })
        ;

        const $mainContainer = $('<div class="table-horizontal-scroll">');
        $mainContainer.append(this._$leftButton);
        $mainContainer.append(this._$rightButton);

        this._$table.before($mainContainer);
        $mainContainer.append(this._$table);

        this._$tableHead.on('scroll', () => {
            this._updateButtons();
        });
        this._$tableBody.on('scroll', () => {
            this._updateButtons();
        });

        $(window).on('resize', () => {
            this.update();
        });

        this._$table.data('hasControls', true);

        // execute a deferred update
        if (this._doUpdate) {
            this.update();
        }
    }

    _mergeConfig() {
        const defaultConfig = {
            scrollStep: 100,
        };

        this._config = {
            ...defaultConfig,
            ...this._config,
        };
    }
}
